import LottieAnimation from './atoms/LottieAnimation';
import getScreenSize from '../utils/getScreenSize';

interface Props {
  slice?: boolean,
}

const CardsLottie = ({ slice = true }: Props) => {
  const height = getScreenSize() === 'lg' || getScreenSize() === 'xl' || getScreenSize() === '2xl' ? '42px' : '30px';
  return (
    <>
      <LottieAnimation height={height} path="/lottie-dark-2.json" className="w-full hidden dark:block" slice={slice} />
      <LottieAnimation height={height} path="/lottie-light-1.json" className="w-full block dark:hidden" slice={slice} />
    </>
  );
};

export default CardsLottie;
